import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback, useMemo } from 'react';
// Create the Loading context
const LoadingContext = createContext(undefined);
// LoadingProvider component to provide loading context to its children
export const LoadingProvider = ({ children }) => {
    const [loadingCount, setLoadingCount] = useState(0);
    const [bindingLoadingCount, setBindingLoadingCount] = useState(0);
    const isLoading = loadingCount > 0;
    const isBindingLoading = bindingLoadingCount > 0;
    // Function to start loading - increments counter
    const startLoading = useCallback((context = 'general') => {
        if (context === 'binding') {
            setBindingLoadingCount(prev => prev + 1);
        }
        else {
            setLoadingCount(prev => prev + 1);
        }
    }, []);
    // Function to stop loading - decrements counter, never goes below 0
    const stopLoading = useCallback((context = 'general') => {
        if (context === 'binding') {
            setBindingLoadingCount(prev => Math.max(prev - 1, 0));
        }
        else {
            setLoadingCount(prev => Math.max(prev - 1, 0));
        }
    }, []);
    const value = useMemo(() => ({ isLoading, isBindingLoading, startLoading, stopLoading }), [isLoading, isBindingLoading, startLoading, stopLoading]);
    return (_jsx(LoadingContext.Provider, { value: value, children: children }));
};
// Custom hook to use the Loading context
export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};
